<div class="container">
    <h1 class="huge-blue">Device Cap Config</h1>
    <div class="checkbox">
        <mat-checkbox class="select" [(ngModel)]="monthlyCapping"></mat-checkbox>
        <div>Monthly Capping</div>
    </div>
    <div class="checkbox">
      <mat-checkbox class="select" [(ngModel)]="uniqueDeviceCap"></mat-checkbox>
      <div>Unique Device Cap</div>
    </div>
    @if (!uniqueDeviceCap) {
        <h3>This device currently has a cap of {{originalCap}}MB</h3>
    } @else {
        <mat-form-field>
          <mat-label>Device Cap Value (MB)</mat-label>
          <input [formControl]="deviceCapControl" matInput numbersOnly>
          @if (deviceCapControl.errors != null) {
            <mat-error>Please enter a valid number</mat-error>
          }
        </mat-form-field>
    }
    <mat-form-field>
        <mat-label>Reason:</mat-label>
        <input [formControl]="reasonControl" matInput>
        @if (reasonControl.errors != null) {
            <mat-error>Please enter a valid reason</mat-error>
        }
      </mat-form-field>
    <div class="buttons">
      <button mat-flat-button (click)="cancel()">Cancel</button>
      <button class="save" mat-flat-button (click)="save()">Save</button>
    </div>
</div>